import { render, staticRenderFns } from "./SourceForm.vue?vue&type=template&id=0e9644c2&scoped=true"
import script from "./SourceForm.vue?vue&type=script&lang=js"
export * from "./SourceForm.vue?vue&type=script&lang=js"
import style0 from "./SourceForm.vue?vue&type=style&index=0&id=0e9644c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9644c2",
  null
  
)

export default component.exports